import Vue from 'vue'
import App from './App.vue'
import router from './router/router'
import store from './store/store'
import vuetify from './plugins/vuetify'
import globalMixin from './mixin/global-mixins'

// Globally register all components inside `_common` folder
import './components/_common/_globals'

import ProfileRedirect from './components/common/profileRedirect.vue'
import DataTracker from './components/common/dataTracker.vue'
import BaseSnackbar from './components/common/baseSnackbar.vue'

Vue.config.productionTip = false
Vue.mixin(globalMixin)
Vue.component('profile-redirect', ProfileRedirect)
Vue.component('data-tracker', DataTracker)
Vue.component('base-snackbar', BaseSnackbar)

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App),
}).$mount('#app')